import React, { useEffect, useMemo, useState } from "react";

import { MapWrapper } from "./styles";
import { useAppSelector } from "../../../../../store";
import { getFullMapsState } from "../../../../../store/slices/maps/maps.slice";
import { DEFAULT_COORDINATES } from "../../../../../constants";

const MapComponent = ({ canEdit = false }: { canEdit: boolean }) => {
	const { coordinates: stateCoordinates } = useAppSelector(getFullMapsState);

	const [coords, setCoords] = useState(DEFAULT_COORDINATES);

	useEffect(() => {
		if (stateCoordinates) {
			setCoords({ lat: stateCoordinates?.lat, lng: stateCoordinates?.lng });
		}
	}, [stateCoordinates]);

	// Google Maps Static API URL
	const mapSrc = useMemo(
		() =>
			`https://maps.googleapis.com/maps/api/staticmap?center=${coords?.lat},${coords?.lng}&zoom=15&size=600x300&markers=color:red%7C${coords?.lat},${coords?.lng}&key=${process.env.REACT_APP_MAPS_API_KEY}`,
		[coords]
	);

	const handleClick = () => {
		if (!canEdit) {
			const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${coords.lat},${coords.lng}`;
			window.open(mapsUrl, "_blank");
		}
	};

	return (
		<MapWrapper onClick={handleClick} rel="noopener noreferrer">
			<img
				src={mapSrc}
				alt={"Wedding map"}
				style={{ borderRadius: "10px", cursor: "pointer", height: "250px", width: "340px", objectFit: "cover" }}
			/>
		</MapWrapper>
	);
};

export default MapComponent;
